export default "__VITE_ASSET__fb15b9d9__$_?component__"